
import {Component, Vue, Prop} from "vue-property-decorator";

@Component
export default class ImportResults extends Vue {
    @Prop({default: false})
    public dialog: boolean;

    @Prop({default: null})
    public type: string;

    @Prop({default: null})
    public stats: any;

    private addIcon() {
        switch (this.type) {
            case "users": return "person_add";
            case "keys": return "add_circle";
            default: return "add_circle";
        }
    }
}
